<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-n3">Why do you want to use a pencil rather than a pen to write on your TLC?</p>

      <v-radio-group v-model="inputs.question1Value" class="ml-6 mb-n6" :disabled="!allowEditing">
        <v-radio
          v-for="option in options"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
          :label="option.text"
        >
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import ChemicalLatex from '../displayers/ChemicalLatex';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'uOttawa1321Prelab1Q10',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        question1Value: null,
      },
      options: [
        {text: 'Ink is soluble in organic solvents', value: 'soluble'},
        {text: 'You want to be able to erase when needed', value: 'erasing'},
        {
          text: 'Ink would have an influence on the migration of organic compounds',
          value: 'inkInfluenceMigration',
        },
        {text: 'A pen would chip the silica more significantly', value: 'moreChipping'},
      ],
    };
  },
};
</script>
